var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0467 6.88001C11.92 6.88001 11.7934 6.83334 11.6933 6.73334L8.00002 3.04001L4.30668 6.73334C4.11335 6.92667 3.79335 6.92667 3.60002 6.73334C3.40668 6.54001 3.40668 6.22001 3.60002 6.02667L7.64668 1.98001C7.84002 1.78667 8.16002 1.78667 8.35335 1.98001L12.4 6.02667C12.5933 6.22001 12.5933 6.54001 12.4 6.73334C12.3067 6.83334 12.1733 6.88001 12.0467 6.88001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.1667C7.72667 14.1667 7.5 13.94 7.5 13.6667V2.44667C7.5 2.17334 7.72667 1.94667 8 1.94667C8.27333 1.94667 8.5 2.17334 8.5 2.44667V13.6667C8.5 13.94 8.27333 14.1667 8 14.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/Arrow-up.7e2d04e6.svg";
export { ForwardRef as ReactComponent };